import { render, staticRenderFns } from "./RsvpAssessoria.vue?vue&type=template&id=706a0509&"
import script from "./RsvpAssessoria.vue?vue&type=script&lang=js&"
export * from "./RsvpAssessoria.vue?vue&type=script&lang=js&"
import style0 from "./RsvpAssessoria.vue?vue&type=style&index=0&id=706a0509&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports